import React, { useRef } from 'react';
import { FaBell } from 'react-icons/fa';
import { CustomToggle } from '../../../components/CustomToggle';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { InfoDescription } from '../../../components/InfoDescription';
import { useNotificationOrder } from '../../../hooks/notificationOrder';
import { songSelectData } from '../constants';
import sound1 from '../../../assets/sounds/notification.mp3';
import sound2 from '../../../assets/sounds/notification2.mp3';
import sound3 from '../../../assets/sounds/notification3.mp3';
import sound4 from '../../../assets/sounds/notification4.mp3';
import sound5 from '../../../assets/sounds/notification5.mp3';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
  LojaInputWrapper,
} from './styles';

const soundMap = {
  1: sound1,
  2: sound2,
  3: sound3,
  4: sound4,
  5: sound5,
};

const Notifications = ({ config, onChange }) => {
  const { hasPermission, requestPermission } = useNotificationOrder();
  const audioRef = useRef(null);

  const playSoundPreview = (soundValue) => {
    const soundFile = soundMap[soundValue];
    if (!soundFile) return;

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    const audio = new Audio(soundFile);
    audio.play();

    audioRef.current = audio;
  };

  const handleSoundChange = (value) => {
    playSoundPreview(value);
    onChange('notificationPushSong')(value);
  };

  return (
    <ContainerLoja>
      <ContentLoja>
        <SettingsCard>
          <CardHeader>
            <FaBell />
            <h3>Alertas e Notificações</h3>
          </CardHeader>

          <ToggleRow>
            <InfoDescription
              label="Habilitar Notificações Push"
              description="Permite que o seu navegador emita um aviso sonoro sempre que um novo pedido chegar, mesmo se a aba estiver em segundo plano."
            />
            <CustomToggle
              id="enablePushNotifications"
              checked={hasPermission}
              onChange={() => requestPermission()}
            />
          </ToggleRow>
          <LojaInputWrapper style={{ marginTop: '10px' }}>
            <InfoDescription
              label="Som do Alerta (Toque)"
              description="Escolha o som que será reproduzido quando um novo pedido chegar. Você pode clicar no nome do som para ouvir uma prévia."
            />
            <CustomSelectPicker
              id="notificationsSongs"
              data={songSelectData}
              value={config.notificationPushSong}
              onChange={handleSoundChange}
              searchable={false}
              cleanable={false}
            />
          </LojaInputWrapper>
        </SettingsCard>
      </ContentLoja>
    </ContainerLoja>
  );
};

export default Notifications;
